import styles from "./TitlePages.module.css"

function TitlePages({ title, subTitle }) {
    return (
        <section className={styles.titlePages}>    
                <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
                <p dangerouslySetInnerHTML={{ __html: subTitle }} ></p>
        </section>
    )
}

export default TitlePages
